import { Link } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess = () => (
  <section className="section success-page">
    <div className="container success-wrap">
      <div className="success-icon">✓</div>
      <h1>Payment Received!</h1>
      <p>Thank you for your order. We have received your payment and will be in touch shortly to confirm the details.</p>
      <p>Questions? Call us on <strong>+265 884 996 996</strong> or email <strong>info@pompanomw.com</strong></p>
      <Link to="/" className="btn btn-primary">Back to Home</Link>
    </div>
  </section>
);

export default PaymentSuccess;